// Mock Conditions Data
// Extracted from demo-data/conditions.ts

export interface ConditionEntry {
  id: string;
  user_id: string;
  condition_name: string;
  diagnosis_date: string;
  severity: 'mild' | 'moderate' | 'severe';
  status: 'active' | 'managed' | 'resolved';
  notes?: string;
  created_at: string;
  updated_at: string;
}

export const mockConditions: ConditionEntry[] = [
  {
    id: '1',
    user_id: 'demo-user-id',
    condition_name: 'Type 2 Diabetes',
    diagnosis_date: '2022-03-15',
    severity: 'moderate',
    status: 'managed',
    notes: 'Well-controlled with diet and medication',
    created_at: '2022-03-15T00:00:00Z',
    updated_at: '2024-01-15T00:00:00Z'
  },
  {
    id: '2',
    user_id: 'demo-user-id',
    condition_name: 'Hypertension',
    diagnosis_date: '2021-08-20',
    severity: 'mild',
    status: 'managed',
    notes: 'Controlled with medication and lifestyle changes',
    created_at: '2021-08-20T00:00:00Z',
    updated_at: '2024-01-15T00:00:00Z'
  },
  {
    id: '3',
    user_id: 'demo-user-id',
    condition_name: 'Asthma',
    diagnosis_date: '2020-05-10',
    severity: 'mild',
    status: 'active',
    notes: 'Seasonal triggers, well-managed with inhaler',
    created_at: '2020-05-10T00:00:00Z',
    updated_at: '2024-01-15T00:00:00Z'
  }
]; 